import toggle from './nav-toggle.js';
import './tabbing-navigation.js';
import SubmenuNavigation from './submenu-navigation.js';
import Search from './search-toggle.js';

import '../sass/style.scss';

( function( $ ) {

    $( document ).ready( function() {

        $( 'body' ).removeClass( 'no-js' );

        let navToggle = new toggle();
        navToggle.init();

        let subNav = new SubmenuNavigation();
        subNav.init();

        let sToggle = new Search();
        sToggle.init();

        $('a[href^="#"]').click( function(event) {
            event.preventDefault();

            // Get the current target hash
            var target = this.hash;
            var $target = $(target);

            // Check if target exists
            if ($target.length) {
                // Animate the scroll bar action so its smooth instead of a hard jump
                $('html, body').stop().animate({
                    'scrollTop': $target.offset().top - 120
                }, 300);
            }

        });

    });

})( jQuery );

// Pure JavaScript back-to-top functionality
document.addEventListener('DOMContentLoaded', function() {

    const backToTop = document.getElementById('back-to-top');

    // Simple scroll listener - just on window
    window.addEventListener('scroll', function() {

        if (window.scrollY > 100) {  // Changed to 10px for testing since page only has 32px scroll
            backToTop.classList.add('is-visible');
        } else {
            backToTop.classList.remove('is-visible');
        }
    });

});
